// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ecommerce__nav-bar_item',
    // #endregion
    // #region Props
    props: {
        menuItem: {
            type: Object,
            required: true,
            default: null
        },
        navBar: {
            type: Object,
            required: true,
            default: null
        },
        align: {
            type: String,
            required: false,
            default: 'left'
        }
    },
    // #endregion
    // #region Methods
    methods: {
        getMenuItemCaption(menuItem) {
            if (menuItem.caption === '$UserName') {
                return this.$t('client.Common.Hello') + " " + this.userDisplayName;
            }
            else {
                return menuItem.caption;
            }
        },
        onShowSubMenu() {
            if (this.navBar._currentItem && this.navBar._currentItem == this.menuItem) {
                this.navBar._currentItem = null;
            }
            else {
                this.navBar._currentItem = this.menuItem;
            }
        }
    },
    // #endregion
});
// #endregion
